{
	"textures": [
		{
			"image": "spritesheet.png",
			"format": "RGBA8888",
			"size": {
				"w": 30,
				"h": 31
			},
			"scale": 1,
			"frames": [
				{
					"filename": "tile-0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 32,
						"h": 32
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 1,
						"w": 28,
						"h": 29
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 28,
						"h": 29
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:93fdd66e7fab63dd962005458d7520fd:016a61f909f1606d3b6415b99936a798:729adc6043343cfda41c447ce8f464d6$"
	}
}
